import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { PriceComponent } from './price/price.component';
import { TranslocoModule } from '@jsverse/transloco';
import { PriceScaleComponent } from './price-scale/price-scale.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { PriceSetupCostsComponent } from './price-setup-costs/price-setup-costs.component';
import { ServicePackageNamePipe, SortTiersPipe } from '@markant-platform/shared/util-pipes';
import { PriceMetadataComponent } from './price-metadata/price-metadata.component';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    MarkantElementsModule,
    SortTiersPipe,
    ServicePackageNamePipe,
    PriceMetadataComponent,
  ],
  exports: [PriceComponent, PriceScaleComponent, PriceSetupCostsComponent],
  providers: [CurrencyPipe, ServicePackageNamePipe],
  declarations: [PriceComponent, PriceScaleComponent, PriceSetupCostsComponent],
})
export class CartridgeUiPriceModule {}
